import { Flex, Grid, Image, Link, Td, Text, Tr } from '@chakra-ui/react';
import { ethers } from 'ethers';
import React from 'react';
import { useNavigate } from 'react-router-dom';
import { containerMaxWXl } from 'src/components/ContentContainer/contentContainer';
import { IGameToken } from 'src/pages/User/user';
import { formatUsd } from 'src/utils/utils';
import { IGame } from '../../../providers/Games/useGames';

export const GameListItem = ({ data, index }: { data: IGame & IGameToken; index: number }) => {
	const history = useNavigate();

	const navigate = () => {
		history(`/game/${data.address}`);
	};

	const today = new Date();
	const twoWeeksBefore = new Date(today.setDate(today.getDate() - 21));
	const createDate = new Date(data.createdAt);
	const isNew = createDate > twoWeeksBefore;

	return (
		<Tr
			maxW={{ base: '100px', xl: containerMaxWXl }}
			overflowX="auto"
			onClick={navigate}
			cursor="pointer"
		>
			<Td>
				<Text fontSize="12px">{index}</Text>
			</Td>
			<Td>
				<Flex
					gap="16px"
					align="center"
				>
					<Image
						src={data?.media?.banner}
						objectFit="cover"
						objectPosition="center"
						w="50px"
						h="50px"
						maxW="50px"
						maxH="50px"
						borderRadius="50%"
					/>
					<Flex
						flexDir="column"
						gap="2px"
					>
						<Text
							fontSize="14px"
							fontWeight="600"
						>
							{data?.name}
						</Text>
						<Text fontSize="12px">{data?.address}</Text>
					</Flex>
				</Flex>
			</Td>
			<Td>
				<Text fontSize="12px">
					{data?.platforms[0] === 'software-key'
						? 'Software key'
						: data?.platforms[0] === 'ticket'
						? 'Ticket'
						: 'Game'}
				</Text>
			</Td>
			<Td>
				<Text fontSize="12px">{data?.color.toUpperCase()}</Text>
			</Td>
			<Td>
				<Text fontSize="12px">{data?.marketplaceFee ? data.marketplaceFee : '0'}%</Text>
			</Td>
			<Td>
				<Text fontSize="12px">{new Intl.NumberFormat().format(parseInt(data?.totalSupply) / 100)}</Text>
			</Td>
			<Td>
				<Text
					fontSize="12px"
					fontWeight="600"
				>
					{formatUsd(ethers.utils.formatUnits(data.price, 4))}
				</Text>
			</Td>
		</Tr>
	);
};
